import tinycolor from "tinycolor2";
import imgs from "../imgs";
var colors = {
    main: "#227268",
    accent1: "#4B5FB3",
    accent2: "#9BA5D5",
    accent3: "#37B1A3",
    accent4: "#D1FAFF",
    accent5: "#3CCDCB",
    accent6: "#2EB2A3",
    accent7: "",
    lightText: "#C3DAD5",
    lightBg: "#F1F7F7",
    lightBg2: "#EBEDF8",
    lightBg3: "#FCFDFD",
    lightBg4: "#ebf9fb",
    textMain: "#2E2F36",
    titleScHeading: "#092927",
    textAlt1: "#3E4248",
    textAlt2: "#1D7268",
    textAlt3: "#639E97",
    textAlt4: "#898A92",
    white: "#fff",
    grey: "#D8D8D8",
    lightGrey: "#FBFCFC",
    black: "#092927",
    success: "#A0E1DA",
    error: "#ef476f",
    warning: "#ffd166",
    notification: "#F25162",
    anchorItemBefore: "#dcdd73",
    anchorItemAfter: "#bdbf09",
    chenin: "#DCDD73",
    rioGrande: "#BDBF09",
    elm: "#1D7268",
    praisWhite: "#C2DAD5",
    geyser: "#C6DADD",
    turquoise: "#3CCDCB",
    ziggurat: "#C1DBDE",
    polar: "#EEF7FB",
    jungleMist: "#B0CED2",
    waterLeaft: "#91E3D9",
    mystic: "#E2EDEA",
    blueWater: "#CCE7CC",
    greenWater: "#EBF2EB",
};
var fontWeight = {
    lightText: "normal",
};
var theme = {
    name: "default",
    gwThemed: {
        sectionHeading: {
            color: colors.titleScHeading,
        },
        logo: imgs.logo,
        header: {
            bg: colors.main,
            color: colors.lightText,
            borderColor: tinycolor(colors.white).setAlpha(0.1).toString(),
        },
        footer: {
            bg: colors.main,
            color: colors.lightText,
            borderColor: tinycolor(colors.white).setAlpha(0.1).toString(),
        },
        topBar: {
            bg: colors.main,
            color: colors.lightText,
            valueColor: colors.lightText,
            borderColor: tinycolor(colors.white).setAlpha(0.1).toString(),
            fontWeight: fontWeight.lightText,
        },
        middleBar: {
            bg: colors.main,
            color: colors.lightText,
            valueColor: colors.lightText,
            borderColor: tinycolor(colors.white).setAlpha(0.1).toString(),
            fontWeight: fontWeight.lightText,
            chevron: colors.lightText,
        },
        leftNav: {
            color: colors.accent3,
            comingSoon: colors.textAlt4,
            bg: colors.lightBg,
            borderColor: colors.white,
            selectedMarkerColor: colors.accent3,
            selectedBg: colors.white,
            subItems: {
                bg: tinycolor(colors.lightBg).lighten(3).toString(),
                hoverBg: colors.lightBg,
            },
        },
        generalContent: {
            bg: colors.white,
            altBg: colors.lightBg3,
            inputSelect: {
                border: {
                    color: colors.accent7,
                },
            },
            text: {
                main: {
                    color: colors.textMain,
                },
                alt: {
                    color: colors.textAlt1,
                },
                light: {
                    color: colors.lightText,
                },
                emphasis: {
                    color: colors.accent3,
                },
                darker: {
                    color: colors.black,
                },
                danger: {
                    color: colors.error,
                },
                link: {
                    color: colors.accent1,
                    hoverColor: tinycolor(colors.accent1).lighten(5).toString(),
                },
                title: {
                    color: colors.main,
                },
            },
            borderRadius: "3px",
            table: {
                borderColor: colors.accent2,
            },
        },
        separator: {
            color: colors.lightBg2,
        },
        alerts: {
            normal: { bg: colors.lightBg2, color: colors.textMain },
            success: { bg: colors.success, color: colors.textMain },
            error: { bg: colors.error, color: colors.white },
            warning: { bg: colors.warning, color: colors.textMain },
        },
        badges: {
            normal: { bg: colors.lightBg, color: colors.textAlt2 },
        },
        accordion: {
            color: colors.accent1,
            lightHoverColor: colors.lightBg2,
            borderColor: colors.accent2,
            bg: colors.white,
            shadow: tinycolor(colors.textAlt2).setAlpha(0.13).toString(),
        },
        loader: {
            color: colors.lightBg2,
        },
        buttons: {
            main: {
                bg: colors.accent1,
                hoverBg: tinycolor(colors.accent1).lighten(5).toString(),
                color: colors.white,
                hoverColor: colors.white,
                lightHoverColor: colors.lightBg2,
            },
            disabled: {
                bg: colors.lightText,
                color: colors.white,
                hoverBg: colors.lightText,
                hoverColor: colors.white,
            },
            selected: {
                bg: colors.lightBg2,
            },
            alt: {
                bg: colors.accent3,
                hoverBg: tinycolor(colors.accent3).lighten(5).toString(),
                color: colors.white,
                hoverColor: colors.white,
            },
            altSelected: {
                bg: colors.lightBg,
            },
            danger: {
                bg: colors.error,
                hoverBg: tinycolor(colors.error).lighten(5).toString(),
                color: colors.white,
                hoverColor: colors.white,
            },
        },
        inputs: {
            main: {
                color: colors.accent1,
                borderColor: colors.accent2,
                bg: colors.white,
                focusBg: tinycolor(colors.lightBg2).lighten(0).toString(),
            },
            alt: {
                color: colors.accent3,
                borderColor: colors.accent3,
                focusBg: colors.lightBg3,
                bg: colors.white,
            },
            disabled: {
                bg: tinycolor(colors.lightBg).lighten(0).toString(),
                focusBg: tinycolor(colors.lightBg).lighten(0).toString(),
                borderColor: colors.lightText,
                color: colors.textMain,
            },
        },
        progressBar: {
            background: colors.lightBg,
            color: colors.accent5,
        },
        startDesign: {
            title: tinycolor(colors.textAlt2).darken(13).toString(),
            counter: {
                color: colors.textAlt3,
                accent: colors.black,
            },
            questions: {
                title: tinycolor(colors.textAlt2).darken(13).toString(),
                bulletPoints: colors.accent3,
                link: {
                    color: colors.accent1,
                },
            },
        },
        karmTool: {
            questionnaire: {
                bg: colors.white,
                section: {
                    borderColor: colors.lightBg2,
                },
                question: {
                    infoIcon: {
                        bg: colors.accent6,
                        color: colors.white,
                    },
                    infoTooltip: {
                        borderColor: colors.lightBg2,
                        bg: colors.white,
                        color: colors.textMain,
                        resourcesColor: tinycolor(colors.accent2).darken(10).toString(),
                    },
                    warnMessage: {
                        color: colors.accent6,
                        icon: {
                            background: colors.accent6,
                        },
                    },
                },
            },
            diagram: {
                bg: colors.white,
                tabs: {
                    color: colors.textAlt3,
                    selectedColor: colors.textAlt2,
                    selectedIndicatorColor: colors.accent3,
                    bg: colors.lightBg,
                    borderColor: colors.lightBg2,
                },
                legend: {
                    color: colors.textAlt2,
                },
                farmDetailsLegendItem: {
                    titleColor: colors.textAlt2,
                },
                array: {
                    colors: {
                        chenin: colors.chenin,
                        rioGrande: colors.rioGrande,
                        elm: colors.elm,
                        praisWhite: colors.praisWhite,
                        geyser: colors.geyser,
                        turquoise: colors.turquoise,
                        ziggurat: colors.ziggurat,
                        polar: colors.polar,
                        jungleMist: colors.jungleMist,
                        waterLeaft: colors.waterLeaft,
                        mystic: colors.mystic,
                    },
                    flotationBuoy: colors.turquoise,
                },
            },
            anchorLine: {
                buoyItem: {
                    before: colors.anchorItemBefore,
                    after: colors.anchorItemAfter,
                },
            },
        },
    },
    colors: colors,
    responsive: {
        mobile_sm: "320px",
        mobile_md: "480px",
        mobile_lg: "620px",
        tablet_md: "720px",
        tablet_lg: "940px",
        desktop_sm: "1100px",
        desktop_md: "1200px",
        desktop_lg: "1350px",
        desktop_xlg: "1500px",
    },
    measures: {
        mobileBleed: "16px",
        tabletBleed: "20px",
        desktopBleed: "25px",
        desktopMaxWidth: "1440px",
        navDesktopWidth: "240px",
        desktopCardWidth: "320px",
        karmNavDesktopWidth: "136px",
        karmDiagramDesktopWidth: "630px",
    },
    z: {
        tooltip: 6000,
        modal: 5000,
        nav: 2000,
        stickyheader: 1000,
        content: 500,
    },
    fontFamilies: {
        ffMain: '"Gotham SSm A", "Gotham SSm B", sans-serif',
        ffAlt: "",
    },
    transitions: {
        normal: "150ms",
        notification: "5000ms",
    },
    borders: {
        radius: "3px",
    },
};
export default theme;
//# sourceMappingURL=gw2020.js.map